export default (theme: any) => ({
    firstRow: {
        paddingBottom: '45px',
    },

    gridItemContent: {
        marginTop: '5px',
        marginBottom: '10px',
        width: '100%',
    },

    button: {
        [theme.breakpoints.between('xs', 'lg')]: {
            minWidth: '100%',
        },
    },

    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        borderRadius: '2px',
    },
})
